import { queueTrackingEvent } from '@library/tracking-integration'

export enum TargetUri {
  MENU = '/menu',
  SIGNUP = '/signup',
  TEN_MINUTE_MEALS = '/menu?collection=10-minute-meals',
  FAMILY = '/menu?collection=family-kitchen',
  PROTEIN_HIT = 'menu?collection=xl-protein-hit',
  CALORIE_CONTROLLED = '/menu?collection=health-hub',
  BOX_PRICES = '/box-prices',
  HOW_GOUSTO_FOOD_BOXES_WORK = '/food-box/how-it-works',
  VEGETARIAN = '/menu?collection=vegetarian',
  SUSTAINABILITY = 'https://www.gousto.co.uk/blog/sustainability',
  SUSTAINABILITY_IMPACT_REPORT = 'https://www.gousto.co.uk/blog/our-2024-impact-report-setting-a-new-standard-for-sustainability',
  SUPPLIERS = 'https://www.gousto.co.uk/blog/suppliers',
  SAFE_SPACE_HELP = 'https://www.gousto.co.uk/help-centre/article/how-do-i-change-my-safe-place-/4420269679505',
}

export enum TrackingActions {
  CLICK_GET_STARTED = 'click_get_started',
  CLICK_RECIPE_NAVIGATION = 'click_recipe_navigation',
  FOOD_BOX_CTA = 'food_box_cta',
  SPEEDY_10_MIN_MEALS_HELP = 'speedy_10_min_meals_help',
  EVERYDAY_FAVOURITES_HELP = 'everyday_favourites_help',
  HOW_GOUSTO_WORKS = 'how_gousto_works_cta',
  BOX_PRICING_NAVIGATION_CLICKED = 'BoxPricingNavigation Clicked',
  SUSTAINABILITY_NAVIGATION_CLICKED = 'SustainabilityNavigation Clicked',
  CALORIE_CONTROLLED_HELP = 'calorie_controlled_help',
  PROTEIN_HIT_HELP = 'protein_hit_help',
  VEG_BOOST_HELP = 'veg_boost_help',
  SUPPLIERS = 'suppliers_cta',
  HELP = 'safe_space_help',
}

export enum HowGoustoFoodBoxesWorkSections {
  HERO_SECTION = 'hero_section',
  FAQ_SECTION = 'faq_section',
  HOW_IT_WORKS_SECTION = 'how_it_works_section',
  WHY_GOUSTO_SECTION = 'why_gousto_section',
  FOOD_BOX_SECTION = 'food_box_section',
  GOUSTO_VALUE_SECTION = 'gousto_value_section',
  GOUSTO_WORTH_SECTION = 'gousto_worth_section',
}

export enum MealPlanningSections {
  HERO_SECTION = 'hero_section',
  EXPLORE_GOUSTO = 'explore_gousto',
  FAQ_SECTION = 'faq_section',
  HOW_DOES_GOUSTO_MENU_WORK = 'how_gousto_menu_works',
  HOW_MUCH_DOES_GOUSTO_COST = 'how_much_does_gousto_cost',
  WHY_CHOOSE_GOUSTO = 'why_choose_gousto',
  EXPLORE_MENU = 'explore_menu',
  MEAL_TYPES = 'meal_types',
}

export enum FoodBoxPageSections {
  HERO_SECTION = 'hero_section',
  FAQ_SECTION = 'faq_section',
  HOW_IT_WORKS_SECTION = 'how_it_works_section',
  FOOD_BOX_SECTION = 'food_box_section',
  GOUSTO_WORTH_SECTION = 'gousto_worth_section',
  BENEFITS_SECTION = 'benefits_section',
  WHATS_INSIDE_SECTION = 'whats_inside_section',
  CONTROL_SECTION = 'control_section',
  FOOD_BOX_BUSY = 'food_box_busy',
  FOOD_BOX_FAMILIES = 'food_box_families',
  FOOD_BOX_VEGGIE = 'food_box_veggie',
  FOOD_BOX_ADVENTUROUS = 'food_box_adventurous',
  FOOD_BOX_HEALTHY = 'food_box_healthy',
  FOOD_BOX_SINGLES = 'food_box_singles',
  GIVE_GOUSTO_A_GO_SECTION = 'give_gousto_a_go_section',
}

type CTAClickTrackingData = {
  action: TrackingActions
  properties: {
    section: HowGoustoFoodBoxesWorkSections | MealPlanningSections | FoodBoxPageSections
    url: TargetUri
  }
}

export function trackCTAClick(
  action: TrackingActions,
  landingPageContentSections:
    | HowGoustoFoodBoxesWorkSections
    | MealPlanningSections
    | FoodBoxPageSections,
  target: TargetUri,
) {
  queueTrackingEvent<CTAClickTrackingData>({
    action,
    properties: {
      section: landingPageContentSections,
      url: target,
    },
  })
}

export function simpleTrackRedirect(
  action: TrackingActions,
  landingPageContentSections:
    | HowGoustoFoodBoxesWorkSections
    | MealPlanningSections
    | FoodBoxPageSections,
  target: TargetUri,
) {
  queueTrackingEvent<CTAClickTrackingData>({
    action,
    properties: {
      section: landingPageContentSections,
      url: target,
    },
  })
}
